export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";